import { companyConfig } from "../company";

export interface RouteConfig {
  path: string;
  title: string;
}

export const routeConfig: Record<string, RouteConfig> = {
  home: {
    path: "/",
    title: `Startseite - ${companyConfig.name}`,
  },
  services: {
    path: "/leistungen",
    title: `Unsere Leistungen - ${companyConfig.name}`,
  },
  gallery: {
    path: "/galerie",
    title: `Referenzgalerie - ${companyConfig.name}`,
  },
  contact: {
    path: "/kontakt",
    title: `Kontakt - ${companyConfig.name}`,
  },
  about: {
    path: "/ueber-uns",
    title: `Über uns - ${companyConfig.name}`,
  },
  imprint: {
    path: "/impressum",
    title: `Impressum - ${companyConfig.name}`,
  },
  privacy: {
    path: "/datenschutz",
    title: `Datenschutzerklärung - ${companyConfig.name}`,
  },
};
